import { useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import './MobileNav.css';

const MobileNav = ({ scrollToSection, setShowBookingModal, navigateToWiseCheck }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavClick = (action) => {
    action();
    setIsOpen(false);
  };

  return (
    <>
      <button 
        className="mobile-menu-button" 
        onClick={toggleMenu}
        data-testid="mobile-menu-toggle"
      >
        {isOpen ? <FiX /> : <FiMenu />}
      </button>

      {isOpen && (
        <div className="mobile-menu-overlay" onClick={toggleMenu} data-testid="mobile-menu-overlay">
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()} data-testid="mobile-menu">
            <button 
              onClick={() => handleNavClick(() => scrollToSection('about'))} 
              className="mobile-nav-link"
              data-testid="mobile-nav-about"
            >
              About
            </button>
            <button 
              onClick={() => handleNavClick(() => scrollToSection('services'))} 
              className="mobile-nav-link"
              data-testid="mobile-nav-services"
            >
              Services
            </button>
            <a 
              href="/login"
              className="mobile-nav-link"
              data-testid="mobile-nav-login"
            >
              Login
            </a>
            <button 
              onClick={() => handleNavClick(navigateToWiseCheck)} 
              className="mobile-nav-link"
              data-testid="mobile-nav-wisecheck"
            >
              Wise Check
            </button>
            <button 
              onClick={() => handleNavClick(() => setShowBookingModal(true))} 
              className="mobile-nav-button"
              data-testid="mobile-nav-book"
            >
              Book a Session
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNav;
